import { createFileRoute } from '@tanstack/react-router'
import { PropertyMappingRuleDetailPage } from '../../../components/PropertyMappingRuleDetailPage'

export const Route = createFileRoute('/$org/property-mapping-rules/$uid')({
  component: PropertyMappingRuleDetailRoute,
})

function PropertyMappingRuleDetailRoute() {
  return <PropertyMappingRuleDetailPage />
}
